import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TPostGenerateCustomerAccountShareableLinkRequest } from "./postGenerateCustomerAccountShareableLink.schema";

export const postGenerateCustomerAccountShareableLink = (
  axios: IAxiosInstance
) => {
  return async (body: TPostGenerateCustomerAccountShareableLinkRequest) => {
    const response = await axios.noRetry.post<ZealApiResponse<string>>(
      "/customer-account/funding-sources",
      body
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
